import { render, staticRenderFns } from "./materialAttribute.vue?vue&type=template&id=c5a8227e&scoped=true"
import script from "./materialAttribute.vue?vue&type=script&lang=js"
export * from "./materialAttribute.vue?vue&type=script&lang=js"
import style0 from "./materialAttribute.vue?vue&type=style&index=0&id=c5a8227e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8227e",
  null
  
)

export default component.exports